import type { ProposalMetaInfo } from '@newStore/documentUI/documentUITypes';

import './ProposalIndicator.scss';
import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ProposalDiffMessage from './ProposalDiffMessage';
import { getBorderLeftColor, getUserColor } from './ProposalIndicatorHelpers';

const ProposalIndicator: React.FC<{
  href: ContentHref;
  parentHref: ContentHref | null;
  proposalMetaInfo: ProposalMetaInfo;
}> = ({ href, proposalMetaInfo, parentHref }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const mode = useSelector((state: RootState) => state.documentUI.mode);
  const borderLeftColor = getBorderLeftColor(proposalMetaInfo, mode);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="redactie-proposal-indicator">
      <div
        className="proposal-line-container"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <div
          className="line"
          style={{
            borderLeftStyle:
              proposalMetaInfo.status === 'SUBMITTED_FOR_REVIEW' ? 'solid' : 'dashed',
            borderLeftColor,
            borderRight: proposalMetaInfo.authors.length > 1 ? '2px solid #3499eb' : undefined,
            paddingRight: proposalMetaInfo.authors.length > 1 ? '2px' : '4px',
          }}
        />
      </div>
      {anchorEl && (
        <ProposalDiffMessage
          href={href}
          parentHref={parentHref}
          proposalMetaInfo={proposalMetaInfo}
          userColor={getUserColor(proposalMetaInfo)}
          anchorEl={anchorEl}
        />
      )}
    </div>
  );
};

export default ProposalIndicator;
